import { getServerData } from 'js/src/libs/server-data';

// Remote images (third-party sites AND our own cdn.lumen5.com) don't send CORS headers, so a
// browser <canvas> can't read their pixels and a cross-origin fetch can't read their bytes.
// Route loads through the Lumen5 media proxy, which refetches server-side and returns them with
// CORS. A page served on an internal hostname (the video creation runner) names the proxy origin
// in SERVER.MEDIA_PROXY_ORIGIN. Otherwise dev uses the local media-proxy container (start with
// `run_dev.sh --media-proxy`, exposed on :7999) and prod uses media-share.<domain>. Mirrors the
// backend's _set_media_proxy_url. Data URIs are same-origin already and pass through untouched.
export function mediaProxyUrl(rawUrl: string): string {
    if (rawUrl.startsWith('data:') || typeof window === 'undefined') return rawUrl;
    return `${mediaProxyOrigin()}/proxy-url/?url=${encodeURIComponent(rawUrl)}`;
}

function mediaProxyOrigin(): string {
    const pageProvidedOrigin = parsePageProvidedOrigin();
    if (pageProvidedOrigin) return pageProvidedOrigin;
    const { hostname, protocol } = window.location;
    return hostname === 'localhost' || hostname === '127.0.0.1'
        ? 'http://localhost:7999'
        : `${protocol}//media-share.${hostname}`;
}

function parsePageProvidedOrigin(): string | null {
    const server = getServerData();
    const configured = server?.MEDIA_PROXY_ORIGIN;
    if (typeof configured !== 'string') return null;
    let url: URL;
    try {
        url = new URL(configured);
    } catch {
        return null;
    }
    const allowedProtocols = server?.DEBUG === true ? ['https:', 'http:'] : ['https:'];
    const isBareOrigin =
        url.pathname === '/' && !url.search && !url.hash && !url.username && !url.password;
    return allowedProtocols.includes(url.protocol) && isBareOrigin ? url.origin : null;
}
